var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.$route.meta && _vm.$route.meta.screenFit)?_c('screen-fit',[_c('router-view')],1):_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }